module.exports = {
  x_of_y_lessons_done: '%{x} von %{y} Lektionen',
  backToOverview: 'Zur Kursübersicht',
  new_contents_are_unfinished: 'Es sind neue Inhalte zu diesem Kurs hinzugekommen. Bitte beende die neuen Inhalte, um den Kurs abzuschließen.',
  content_passed: 'Bestanden',
  preview_doesnt_persist_results: 'In der Vorschau werden Ergebnisse nicht erfasst.',
  noRelatedData: {
    appointment: 'Diesem Inhalt ist kein Termin zugewiesen.',
    questions: 'Diesem Inhalt sind keine Fragen zugewiesen.',
    certificate: 'Diesem Inhalt ist kein Zertifikat zugewiesen.',
    form: 'Diesem Inhalt ist kein Formular zugewiesen.',
    learningMaterial: 'Diesem Inhalt ist keine Datei zugewiesen.',
    todoList: 'Diesem Inhalt sind keine Aufgaben zugewiesen.',
  },
  lessonsPassed: 'abgeschlossen',
  restartPreview: 'Vorschau neu starten',
  no_chapters: 'Dieser Kurs hat derzeit keine sichtbaren Inhalte.',
  filters: {
    active: 'Aktiv',
    expired: 'Abgelaufen',
    finished: 'Abgeschlossen',
    started: 'Gestartet',
    all: 'Alle',
    mandatory: 'Verpflichtend',
    preview: 'Vorschau',
  },
  reset_course_progress_failed: 'Das Zurücksetzen von deinem Kursfortschritt hat nicht geklappt!',
  show_all: 'Alle anzeigen',
  look_at_question: 'Fragen noch einmal ansehen',
  show_results: 'Ergebnisse anzeigen',
  sortLabels: {
    name_asc: 'Alphabetisch (A-Z)',
    name_desc: 'Alphabetisch (Z-A)',
    available_from_asc: 'Datum (älteste zuerst)',
    available_from_desc: 'Datum (neuste zuerst)',
    recent: 'Zuletzt',
  },
  access_request_succeeded: 'Wir haben deine Anfrage erhalten und bearbeiten sie schnellstmöglich.',
  navigationTutorialDesktop: 'Klicke auf die Vor- und Zurück-Icons, um durch die Lektionen zu navigieren.',
  navigationTutorialMobile: 'Swipe nach rechts oder links, um durch die Lektionen zu navigieren.',
  almostDone: {
    title: 'Fast geschafft!',
    needToFinishContentsFirst: 'Bevor du den Kurs bestanden hast, musst du noch ein paar Inhalte abschließen.',
    goToFirstUnfinishedContent: 'Zum ersten offenen Kursinhalt',
    moreUnfinishedContent: 'Und 1 weiterer... | Und {count} weitere...',
    followingContentsUnfinished: 'Folgende Inhalte sind noch offen:',
  },
  course_done: 'Du hast den Kurs "%{title}" erfolgreich bestanden!',
  all_chapter_contents_done: 'Du hast alle Lektionen im Kapitel "%{title}" abgeschlossen.',
  received_certificate: 'Du hast ein neues Zertifikat erworben!',
  admin_preview: {
    reason: {
      template: 'Du betrachtest die Vorlage „%{course}“.',
      archived: 'Der Kurs „%{course}“ ist archiviert.',
      not_yet_available: 'Der Kurs „%{course}“ ist noch nicht verfügbar.',
      invisible: 'Der Kurs „%{course}“ ist nicht sichtbar.',
      not_available_anymore: 'Der Kurs „%{course}“ ist nicht mehr verfügbar.',
    },
    close: 'Vorschau schließen',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    available_from_asc: 'Älteste',
    available_from_desc: 'Neuste',
    name_desc: 'Z-A',
  },
  congratulations: 'Kapitel abgeschlossen!',
  updateAppRequired: 'Um am Kurs teilzunehmen, musst du deine App aktualisieren.',
  request_access: 'Zugriff anfragen',
  certificates: {
    unfinishedCertificateTitle: 'Zertifikat',
    unfinishedCertificateDescription: 'Um dieses Zertifikat zu erhalten, musst du zuerst die vorherigen Kursinhalte abschließen.',
    certificateVersion1NotAvailableInPreview: 'Version 1 des Zertifikats ist nicht verfügbar im Vorschaumodus. Bitte aktualisiere auf Version 2.',
  },
  received_certificate_x: 'Zertifikat "%{x}" erworben',
  earned_certificate: 'Zertifikat erworben',
  continue: 'Fortsetzen',
  continue_with_chapter: 'Weiter mit Kapitel "%{title}"',
  has_certificate: 'Mit Zertifikat',
  finish_course: 'Kurs abschließen',
  mandatory_course: 'Pflichtkurs',
  search_course: 'Kurs suchen',
  courses_todo: 'Ausstehende Kurse',
  reset_participation_progress_confirm: 'Bist du sicher, dass du deinen Fortschritt für diesen Kurs dauerhaft zurücksetzen möchtest?',
  reloadPageToGetUpdates: 'Bitte lade die Seite neu, um das neueste Update zu bekommen.',
  download_certificate_now: 'Zertifikat jetzt herunterladen',
  congratulations_course_done: 'Herzlichen Glückwunsch!',
  contentsList: {
    content_unfinished: 'Offen',
    lessons: 'Lektionen',
    courseEnd: 'Kursende',
  },
  go_to_course: 'Zum Kurs',
  details: 'Details',
  access_request_failed: 'Die Anfrage war leider nicht erfolgreich.',
  reset_participation_progress: 'Kursfortschritt zurücksetzen',
  congratulationsCertificate: 'Glückwunsch!',
  show_less: 'Weniger anzeigen',
  lessonsXofY: '{passed} / {total} Lektionen',
  currently_no_courses_visible: 'Hier gibt es aktuell keine Kurse.',
  preview_info: 'Die Teilnahme an diesem Kurs ist derzeit nicht möglich. Bei Interesse kannst du über diesen Link die Freigabe des Kurses bei deinem %{appname} Team beantragen.',
  back_to_course_overview: 'Zurück zur Kursübersicht',
  next_chapter: 'Kapitel abschließen',
  loadingQuestions: 'Fragen werden geladen...',
  courseContentInvisible: 'Dieser Inhalt ist noch nicht veröffentlicht und ist für User nicht sichtbar.',
  go_to_first_new: 'Zum ersten neuen Inhalt',
  participate: 'Starten',
  content_started: 'Gestartet',
  previous_lesson: 'Vorherige Lektion',
  next_lesson: 'Nächste Lektion',
  lessons: 'Lektionen',
  course_manager: 'Kursmanager',
  could_not_participate: 'Die Kursteilnahme ist leider fehlgeschlagen. Bitte versuche es später erneut.',
  didnt_earn_certificate_yet: 'Noch nicht erworben',
  content_failed: 'Nicht bestanden',
  appUpdateRequired: 'App-Update erforderlich',
  menuTutorialMobile: 'Klicke auf den Kapitelnamen oben links, um das Menü zu öffnen.',
  preview_label: 'Vorschau',
  preview_btn: 'Vorschau',
  confirm_reset_participation_progress: 'Ja, meinen gesamten Fortschritt löschen',
  clozeQuestionResetNotification: 'Deine Antwort auf diese Frage wurde zurückgesetzt, da die Frage von einem Administrator aktualisiert wurde.',
  content: {
    hotspots: {
      title: 'Hotspots',
      selectMarker: 'Wähle einen Marker, um Details zu sehen.',
    },
  },
  answer_questions_now: 'Fragen beantworten',
  start_course: 'Diesen Kurs starten',
  endOfPreview: 'Dies ist das Ende der Kursvorschau. In der Vorschau werden Ergebnisse nicht erfasst, du kannst die Vorschau also jederzeit neu starten.',
  reset_course_progress_successful: 'Dein Fortschritt wurde erfolgreich zurückgesetzt! Du kannst jetzt wieder teilnehmen.',
  menuTutorialDesktop: 'Oben rechts kannst du das Menü öffnen.',
  answered_all_preview_questions: 'Alle Fragen in der Vorschau beantwortet.',
  tasks: 'Aufgaben',
  checkForUpdates: 'Nach Updates suchen',
  learning_duration: 'Lernzeit',
  answered_x_of_y_questions_correctly: 'Du hast {correct} von einer Frage richtig beantwortet.|Du hast {correct} von {total} Fragen richtig beantwortet.',
  next_new_lesson: 'Nächste neue Lektion',
  no_chapters_email_contact: 'Bitte wende dich an: %{email}',
  look_at_questions: 'Fragen noch einmal ansehen',
  content_unfinished: 'Offen',
  appUpdatedButNotShowingContent: 'Wenn deine App schon auf dem neuesten Stand ist, melde dich bitte bei deinem <a href="mailto:{contactMail}">Administrator.</a>',
}
